"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var CapitalCostComponent = /** @class */ (function () {
    function CapitalCostComponent() {
    }
    CapitalCostComponent.prototype.ngOnInit = function () {
    };
    return CapitalCostComponent;
}());
exports.CapitalCostComponent = CapitalCostComponent;
